import createClient from '../../helpers/api-client';

const storeSuffix = 'Request';

// Actions
export const FETCH_REQUEST_BY_ID = `fetchRequestByIdAction${storeSuffix}`;
export const FETCH_REQUEST_ANSWER = `fetchRequestAnswerAction${storeSuffix}`;
export const UPDATE_MESSAGE = `updateMessageAction${storeSuffix}`;
export const SEND_ANSWER = `sendAnswerAction${storeSuffix}`;

// Mutations
export const BEGIN_FETCH = `beginFetchMutation${storeSuffix}`;
export const RECEIVED_DATA = `receivedDataMutation${storeSuffix}`;
export const SET_ERROR = `setErrorMutation${storeSuffix}`;

export const SET_MESSAGE = `setAnswerMessageMutation${storeSuffix}`;

export const BEGIN_SEND_ANSWER = `beginSendAnswerMutation${storeSuffix}`;
export const ANSWER_NOT_SENT = `answerNotSentMutation${storeSuffix}`;
export const ANSWER_SENT = `answerSentMutation${storeSuffix}`;
export const RESET_STATE = `resetStateMutation${storeSuffix}`;
export const INCREMENT_ANSWER_COUNT = `incrementAnswerCountMutation${storeSuffix}`;

// Getters
export const GET_ANSWER_INFO = `getAnswerInfoGetter${storeSuffix}`;
export const GET_MESSAGE = `getAnswerMessageGetter${storeSuffix}`;
export const GET_REQUEST = `getRequestGetter${storeSuffix}`;
export const IS_LOADING = `getIsLoadingGetter${storeSuffix}`;
export const GET_ERROR = `getErrorGetter${storeSuffix}`;
export const IS_SENDING = `isSendingGetter${storeSuffix}`;
export const GET_SEND_ERROR = `getSendErrorGetter${storeSuffix}`;

export const modelState = () => ({
    request: {
        isLoading: true,
        error: null,
        data: {},
    },
    requestAnswer: {
        isLoading: true,
        error: null,
        data: null,
        isSending: true,
        sendError: false,
        answerMessage: '',
    },
});

export const actions = {
    [FETCH_REQUEST_BY_ID]: async ({ state, commit }, { id, query }) => {
        return new Promise(async (resolve, reject) => {
            const isAuthenticated = state.authentication.authenticated;
            const apiClient = createClient(state, {
                headers: {
                    Authorization: isAuthenticated
                        ? `Bearer ${state.authentication.authenticationToken}`
                        : '',
                },
            });

            commit(BEGIN_FETCH, 'request');

            try {
                const response = await apiClient.get(`/api/request/${id}`, {
                    params: query,
                });

                const textResponse = await apiClient.get(`/api/metadata/mailtext/1`);          
                commit(RECEIVED_DATA, { key: 'request', payload: response, messagePayload: textResponse});

                resolve(response);
            } catch (error) {
                commit(SET_ERROR, { key: 'request', payload: error });
                resolve(error);
            }
        });
    },
    [FETCH_REQUEST_ANSWER]: async ({ state, commit }, id) => {
        return new Promise(async (resolve, reject) => {
            const apiClient = createClient(state);

            commit(BEGIN_FETCH, 'requestAnswer');

            try {
                const response = await apiClient.get(
                    `/api/request-answer/${id}`
                );
                commit(RECEIVED_DATA, {
                    key: 'requestAnswer',
                    payload: response,
                });

                resolve(response);
            } catch (error) {
                commit(SET_ERROR, {
                    key: 'requestAnswer',
                    payload: error.response,
                });
                resolve(error);
            }
        });
    },
    [SEND_ANSWER]: ({ state, commit }, id) => {
        return new Promise(async (resolve, reject) => {
            const apiClient = createClient(state);

            commit(BEGIN_SEND_ANSWER);

            try {
                const data = {
                    Message: state.requestAnswer.answerMessage,
                    Id: id,
                };
                const res = await apiClient.post(
                    `/api/send-request-answer/${id}`,
                    data
                );

                commit(ANSWER_SENT, res);
                resolve(res);
            } catch (error) {
                commit(ANSWER_NOT_SENT);
                reject(error);
            }
        });
    },
};

export const mutations = {
    [BEGIN_FETCH]: (state, key) => {
        state[key].isLoading = true;
        state[key].error = null;
        state[key].data = {};
    },
    [RECEIVED_DATA]: (state, { key, payload, messagePayload }) => {
        const { data } = payload;
        state[key].isLoading = false;
        state[key].error = null;
        state[key].data = key == 'request' ? data.Request : data;
        if(key == 'request' && messagePayload) {
            const {data} = messagePayload;
            
            var mailMessage = 'Hej!\n\nVi är intresserade av ditt projekt. Det är oftast en fördel med ett platsbesök eller en diskussion innan vi kan lämna offert. Om inte vi hör av oss till dig inom kort, är det bra om du kontaktar oss. Våra kontaktuppgifter ser du nedan.\n\nVi ser fram emot en fortsatt diskussion.'
            if(data && data["message"]) {
                mailMessage = data["message"]
            }
            state.requestAnswer.answerMessage = mailMessage;
        }
    },
    [SET_ERROR]: (state, { key, payload }) => {
        state[key].isLoading = false;
        state[key].error = payload;
    },
    [SET_MESSAGE]: (state, message) => {
        if (message) {
            state.requestAnswer.answerMessage = message;
        }
    },
    [BEGIN_SEND_ANSWER]: state => {
        state.requestAnswer.isSending = true;
        state.requestAnswer.sendError = false;
    },
    [ANSWER_NOT_SENT]: state => {
        state.requestAnswer.isSending = false;
        state.requestAnswer.sendError = true;
    },
    [ANSWER_SENT]: (state, payload) => {
        const { data } = payload;
        state.requestAnswer.isSending = false;
        state.requestAnswer.sendError = false;
        state.requestAnswer.data = data.answerInfo;
        state.request.data.User = data.userInfo;
    },
    [INCREMENT_ANSWER_COUNT]: state => {
        if (typeof state.request.data.AnswerCount == 'undefined') return;

        state.request.data.AnswerCount++;
    },
    [RESET_STATE]: state => {
        state.requestAnswer.data = null;
    }
};

export const getters = {
    [GET_REQUEST]: state => {
        return state.request.data;
    },
    [IS_LOADING]: state => {
        return key => {
            return state[key].isLoading;
        };
    },
    [GET_ERROR]: state => {
        return key => {
            return state[key].error;
        };
    },
    [GET_ANSWER_INFO]: state => {
        return state.requestAnswer.data;
    },
    [GET_MESSAGE]: state => {
        return state.requestAnswer.answerMessage;
    },
    [IS_SENDING]: state => {
        return state.requestAnswer.isSending;
    },
    [GET_SEND_ERROR]: state => {
        return state.requestAnswer.sendError;
    },
};



// WEBPACK FOOTER //
// ./src/store/store-models/request-model.js